import React from 'react';
import PropTypes from 'prop-types';

import { generateUUID } from '../../utils/uuid';
import { formatUnixDate } from '../../utils/formatting_utils';

import ActivityDetails from './activity_details.jsx';
import { ActivityFormEventHandler, ActivityFormEvents } from '../../process/events/activity_form_event_handler';

import { ProcessAPI } from 'lecom-api';

import { getParamUrl } from '../../utils/query_string_parser';
const newWS = getParamUrl("newWS") === "true";
const processMultiple = getParamUrl("processMultiple") === "true";
import RealizeFlash from 'realize/components/flash/flash';

// const RealizeFlash = window.Flash;

export default class ActivityFormResultMessages extends React.Component {
	static propTypes = {
		processInstanceData: PropTypes.object,
		formResultMessages: PropTypes.array
	};

	static defaultProps = {
		processInstanceData: {},
		formResultMessages: [
			{
				activityInstanceData: null,
				messages: [
					{
						message: "",
						htmlSafe: false
					}
				]
			}
		]
	};

	componentDidMount() {
		ActivityFormEventHandler.publish(ActivityFormEvents.DISPLAY_FORM_RESULT_MESSAGES);

		this.focusBtnBack() ;
	}

	focusBtnBack(){
		let btnBack = $('.btn-back');
		let btnVisible = btnBack.is(':visible') ? true : false;

		if(btnVisible === true){
			btnBack.attr('tabindex', '0').focus();
			btnBack.keypress((e) => {
				e.currentTarget.click();
			})
		}
	}

	parseActivityInstanceData(activityInstanceData) {
		return Object.assign({}, activityInstanceData, {
			activityTitle: (!!activityInstanceData.activityName ? activityInstanceData.activityName : activityInstanceData.activityTitle),
			activityStartDate: formatUnixDate(activityInstanceData.startDate),
			activityDueDate: formatUnixDate(activityInstanceData.dueDate)
		});
	}

	handleBackButtonClick() {
		ActivityFormEventHandler.publish(ActivityFormEvents.BACK_TO_START);
	}

	createHtmlSafeMessageObject(messageObj) {
		return {
			__html: messageObj.message
		};
	}

	renderMessages(messages) {
		return messages.map((message) => (
			<RealizeFlash message={message.message} canDismiss={false} type={message.type || 'info'} /> 
		));
	}

	renderBackButton() {
		if(!ProcessAPI.currentProcess()){
			const message = Realize.i18n.t('form.errors.is_public');
			console.warn(message);
		}
		else {
			const isPublic = ProcessAPI.currentProcess().isPublic();

			if (this.props.isMobile || isPublic || processMultiple)
				return <span />;

			return (
				<Button
				name={Realize.i18n.t('actions.back')}
				element="a"
				icon="replay"
				onClick={this.handleBackButtonClick}
				className="btn-back" />
			);
		}
	}

	renderFormResultMessagesItem(formResultMessagesItem) {
		const { activityInstanceData, messages } = formResultMessagesItem;
		const activityDetailsProps = !!activityInstanceData ?
		this.parseActivityInstanceData(activityInstanceData) :
		this.props.processInstanceData;

		return (
			<div className="card" key={`formResultMessages_${activityDetailsProps.activityInstanceId}`}>

				{newWS !== true &&
					<ActivityDetails {...activityDetailsProps} />
				}

				<div className="card-content">
					<div className="activity-form-return-messages">
						<div className="activity-form-return-messages__list">
							{this.renderMessages(messages)}
						</div>
						<div className="activity-form-return-messages__buttons">
							{this.renderBackButton()}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div>
				{this.props.formResultMessages.map(this.renderFormResultMessagesItem.bind(this))}
			</div>
		);
	}
}
